const TierValidation = (values) => {
  const errors = {};

  if (!values.conditions) return errors;
  if (!values.priviledges) return errors;
  if (!values.name) {
    errors.name = "Name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  if (!values.conditions[0]?.value && values.conditions[0]?.value !== 0) {
    errors.tier_condition_value = "Money required is required";
  }

  if (!values.privileges[0]?.item.coupon_id) {
    errors.coupon_id = "Benefit is required";
  }
  if (
    !values.privileges[0]?.item.value &&
    values.privileges[0]?.item.value !== 0
  ) {
    errors.coupon_value = "Benefit value is required";
  }

  if (!values.level && values.level !== 0) {
    // You can return translation keys
    errors.level = "Level is required";
  }

  return errors;
};

export default TierValidation;
